import { useEffect } from 'react';
import ReactGA from 'react-ga';
import logo from './logo.svg';
import './App.css';
import EmployerCostCalculator from "./components/CalcWidget"

ReactGA.initialize('G-GRVQ5Y6F2N');

function App() {
  useEffect(() => {
    ReactGA.pageview("Hiring Calc");
  }, []);
  return (
    <div className="App">
      <EmployerCostCalculator/>
    </div>
  );
}

export default App;
